import { Component, Host, h, Element, Prop } from "@stencil/core";

import { StzhStatusType } from "../../index";

/**
 */
@Component({
  tag: "stzh-status",
  styleUrl: "stzh-status.scss",
  scoped: true,
})
export class StzhStatus {
  /** Percent */
  @Prop() percent: number = 0;

  /** Whether to hide/show loadingbar */
  @Prop({ reflect: true }) withLoadingbar: boolean = false;

  /** Label */
  @Prop() label: string = "";

  /** Type */
  @Prop({ reflect: true }) type: StzhStatusType = "default";

  @Element() element: HTMLStzhStatusElement;

  render() {
    const classes = {
      "stzh-status": true,
      [`stzh-status--type-${this.type}`]: !!this.type,
    };

    return (
      <Host>
        <div class={classes}>
          <div class="stzh-status__text">
            {!this.withLoadingbar && <div class="stzh-status__dot"></div>}
            {this.label && <div class="stzh-status__label">{this.label}</div>}
          </div>
          {this.withLoadingbar && (
            <div class="stzh-status__bar">
              <div
                class="stzh-status__bar-inner"
                style={{
                  width: `${this.percent}%`,
                }}
              ></div>
            </div>
          )}
        </div>
      </Host>
    );
  }
}
